module.exports = __webpack_public_path__ + "static/meo-doors-background-8d40f5abeafbc2b9964fc964cd5204cd.png";